import styled from 'styled-components';

import { BaseButton } from './BaseButton';

export const LeftButton = styled(BaseButton)`
    bottom: 0;
    left: 0;
`;
